/**
 * @file cps h5顶部推广条的脚本
 * @author rockli
 */

(function () {
    $(function () {

        var firstTipHtml = [
            '<div class="mod-cps-extend-first-tip js-cps-extend-first-tip">',
                '<div style="background-image: url(//f4.jiejiatech.net/y16/0303/1442/00mcz_o.png)" class="img-bg">',
                    '<a href="javascript:;" class="js-cps-tip-close button-ok"></a>',
                '</div>',
            '</div>'
        ].join('');

        /**
         * 初始化第一次显示cps工具条的引导层
         */
        function initFirstTip() {
            if (!localStorage.getItem('cpsFirstTipIsShow')) {
                var $firstTip = $(firstTipHtml);
                var $cpsExtendTopbar = $('.mod-cps-extend-topbar');

                $cpsExtendTopbar.css('border', '1px solid #fa6a00');

                $firstTip.appendTo($('body')).css({
                    top: $cpsExtendTopbar.outerHeight() + 'px'
                });

                // 绑定关闭事件
                $firstTip.on('click', '.js-cps-tip-close', function () {
                    $firstTip.hide();
                    $cpsExtendTopbar.css('border', 'none')
                        .css('borderBottom', '1px solid #ccc');
                });

                try {
                    localStorage.setItem('cpsFirstTipIsShow', true)
                } catch (e) {}
            }
        }

        /**
         * 绑定滚动的事件
         */
        function initScrollEvent() {
            var $cloneCpsBar = $('.mod-cps-extend-topbar')
                .clone(true).css({
                    position: 'fixed',
                    display: 'none',
                    width: '100%',
                    top: 0,
                    left: 0,
                    zIndex: 19999,
                    border: 'none'
                }).css({
                   borderBottom: '1px solid #ccc'
                }).appendTo($('body'));

            $(window).on('scroll', function () {
                if ($(window).scrollTop() > 0) {
                    $cloneCpsBar.show();
                }
                else {
                    $cloneCpsBar.hide();
                }
            });
        }

        function bindEvents() {
            var $cpsExtendShare = $('.js-cps-extend-share');
            var shareTitle = encodeURIComponent($("meta[name='share-title']").attr("content")) ;
            var shareImg = encodeURIComponent($("meta[name='share-img']").attr("content")) ;
            var shareDetail = encodeURIComponent($("meta[name='share-detail']").attr("content")) ;
            
            var href = $('#js-cps-share-copy').attr('href') || window.location.href;
            var shareUrl = encodeURIComponent(href);

            $cpsExtendShare.find(".wxhy").attr("href","shijiebang://cps/share?url="+shareUrl+"&title="+shareTitle+"&image="+shareImg+"&detail="+shareDetail+"&sns=1");
            $cpsExtendShare.find(".wxpyq").attr("href","shijiebang://cps/share?url="+shareUrl+"&title="+shareTitle+"&image="+shareImg+"&detail="+shareDetail+"&sns=2");
            $cpsExtendShare.find(".wb").attr("href","shijiebang://cps/share?url="+shareUrl+"&title="+shareTitle+"&image="+shareImg+"&detail="+shareDetail+"&sns=0");


            $('.js-cps-extend-btn').on('click', function () {
                // 如果引导层关掉引导层
                $('.js-cps-extend-first-tip').hide();
                $cpsExtendShare.show();
            });

            $('.js-cps-share-close').on('click', function () {
                $cpsExtendShare.hide();
            });

            $('#js-cps-share-copy').on('click', function (e) {
                e.preventDefault ? e.preventDefault() : e.returnValue = false ;
            });

            initScrollEvent();
        }

        function init() {
            if ($('.mod-cps-extend-topbar').length) {
                // 有工具条时判断是否显示引导层
                initFirstTip();
                bindEvents();
            }
        }

        init();
    });
})();



// WEBPACK FOOTER //
// ./src/module/cps-extend-topbar.js